import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { TarefasEmpresaComponent } from './empresas/tarefas-empresa/tarefas-empresa.component';
import { FichaDaObraComponent } from './ficha-da-obra/ficha-da-obra.component';
import { ResultadoFiltrosComponent } from './filtros-buscas-modulos/resultado-filtros/resultado-filtros.component';
import { AlterarDadosCadastraisComponent } from './header/perfil-usuario/alterar-dados-cadastrais/alterar-dados-cadastrais.component';
import { AlterarSenhaComponent } from './header/perfil-usuario/alterar-senha/alterar-senha.component';
import { MeuPerfilComponent } from './header/perfil-usuario/meu-perfil/meu-perfil.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { RedefinirSenhaComponent } from './login/redefinir-senha/redefinir-senha.component';
import { MetricasComponent } from './metricas/metricas.component';
import { authGuard } from './shared/services/auth/auth.guard';
import { naoRestritoGuard } from './shared/services/auth/nao-restrito.guard';
import { TarefasComponent } from './tarefas/tarefas.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'redefinir-senha/:token', component: RedefinirSenhaComponent },

  { path: '', component: HomeComponent, canActivate: [authGuard] },

  { path: 'usuario', component: MeuPerfilComponent, canActivate: [authGuard] },
  {
    path: 'usuario/senha',
    component: AlterarSenhaComponent,
    canActivate: [authGuard],
  },
  {
    path: 'usuario/dados-cadastrais',
    component: AlterarDadosCadastraisComponent,
    canActivate: [authGuard],
  },

  {
    path: 'obras/carteira',
    canActivate: [authGuard, naoRestritoGuard],
    loadComponent: () =>
      import('./home/listagem-obras/carteira-obras/carteira-obras.component').then(
        (m) => m.CarteiraObrasComponent,
      ),
  },
  {
    path: 'obras/minha-carteira',
    canActivate: [authGuard, naoRestritoGuard],
    data: { aba: 'minhas' },
    loadComponent: () =>
      import('./home/listagem-obras/carteira-obras/carteira-obras.component').then(
        (m) => m.CarteiraObrasComponent,
      ),
  },
  {
    path: 'obras/carteira-equipe',
    canActivate: [authGuard, naoRestritoGuard],
    data: { aba: 'equipe' },
    loadComponent: () =>
      import('./home/listagem-obras/carteira-obras/carteira-obras.component').then(
        (m) => m.CarteiraObrasComponent,
      ),
  },
  {
    path: 'obras/nao-vistas',
    canActivate: [authGuard, naoRestritoGuard],
    data: { aba: 'nao-vistas' },
    loadComponent: () =>
      import('./home/listagem-obras/carteira-obras/carteira-obras.component').then(
        (m) => m.CarteiraObrasComponent,
      ),
  },

  {
    path: 'estatisticas',
    component: DashboardComponent,
    canActivate: [authGuard, naoRestritoGuard],
  },
  {
    path: 'relatorios',
    component: MetricasComponent,
    canActivate: [authGuard],
  },
  { path: 'tarefas', component: TarefasComponent, canActivate: [authGuard] },
  {
    path: 'empresas/tarefas',
    component: TarefasEmpresaComponent,
    canActivate: [authGuard, naoRestritoGuard],
  },

  {
    path: 'buscas/imobiliario',
    component: ResultadoFiltrosComponent,
    canActivate: [authGuard, naoRestritoGuard],
  },
  {
    path: 'buscas/industrial',
    component: ResultadoFiltrosComponent,
    canActivate: [authGuard, naoRestritoGuard],
  },
  {
    path: 'buscas/edificacoes',
    component: ResultadoFiltrosComponent,
    canActivate: [authGuard, naoRestritoGuard],
  },
  {
    path: 'buscas/infraestrutura',
    component: ResultadoFiltrosComponent,
    canActivate: [authGuard, naoRestritoGuard],
  },
  {
    path: 'buscas/:modulo/detalhes/:id',
    component: FichaDaObraComponent,
    canActivate: [authGuard],
  },

  {
    path: 'busca/empresa',
    canActivate: [authGuard, naoRestritoGuard],
    loadComponent: () =>
      import('./buscas/buscas-empresa/buscas-empresa.component').then(
        (m) => m.BuscasEmpresaComponent,
      ),
  },
  {
    path: 'busca/obra',
    canActivate: [authGuard, naoRestritoGuard],
    loadComponent: () =>
      import('./buscas/buscas-id-obra/buscas-id-obra.component').then(
        (m) => m.BuscasIdObraComponent,
      ),
  },
  {
    path: 'busca/salvas',
    canActivate: [authGuard, naoRestritoGuard],
    loadComponent: () =>
      import('./buscas/buscas-salvas/buscas-salvas.component').then(
        (m) => m.BuscasSalvasComponent,
      ),
  },
  {
    path: 'busca/salvas/editar/:id',
    canActivate: [authGuard, naoRestritoGuard],
    loadComponent: () =>
      import('./buscas/buscas-salvas/buscas-salvas.component').then(
        (m) => m.BuscasSalvasComponent,
      ),
  },

  { path: 'empresas', redirectTo: 'empresas', pathMatch: 'full' },

  {
    path: 'empresas/salvas',
    canActivate: [authGuard, naoRestritoGuard],
    loadComponent: () =>
      import('./empresas/empresas-salvas/empresas-salvas.component').then(
        (m) => m.EmpresasSalvasComponent,
      ),
  },
  {
    path: 'empresas',
    canActivate: [authGuard, naoRestritoGuard],
    loadComponent: () =>
      import('./empresas/empresas.component').then((m) => m.EmpresasComponent),
  },
  {
    path: 'empresas/minha-carteira',
    canActivate: [authGuard, naoRestritoGuard],
    loadComponent: () =>
      import('./empresas/minha-carteira-empresas/minha-carteira-empresa.component').then(
        (m) => m.MinhaCarteiraEmpresasComponent,
      ),
  },
  {
    path: 'empresas/detalhes/:module/:id',
    canActivate: [authGuard, naoRestritoGuard],
    loadComponent: () =>
      import('./empresas/empresa-detalhes/empresa-detalhes.component').then(
        (m) => m.EmpresaDetalhesComponent,
      ),
  },
  {
    path: 'empresas/detalhes/:module/:id/:aba',
    canActivate: [authGuard, naoRestritoGuard],
    loadComponent: () =>
      import('./empresas/empresa-detalhes/empresa-detalhes.component').then(
        (m) => m.EmpresaDetalhesComponent,
      ),
  },

  {
    path: '404',
    loadComponent: () =>
      import('./shared/components/pagina-nao-encontrada/pagina-nao-encontrada.component').then(
        (m) => m.PaginaNaoEncontradaComponent,
      ),
  },

  { path: 'default.asp', redirectTo: '', pathMatch: 'full' },
  { path: 'Home/default.asp', redirectTo: '', pathMatch: 'full' },

  { path: '**', redirectTo: '404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
